let mapStatesStash = [];

export default {
  methods: {
    saveMapState(map) {
      if (!map) return;
      mapStatesStash = [map, ...mapStatesStash];
    },
    restoreMapState(callback) {
      if (!mapStatesStash.length) return;
      callback(mapStatesStash.shift());
    },
  },
  beforeDestroy() {
    mapStatesStash = [];
  },
  created() {
    mapStatesStash = [];
    this.$root.$off('saveMapState');
    this.$root.$on('saveMapState', this.saveMapState);

    this.$root.$off('restoreMapState');
    this.$root.$on('restoreMapState', this.restoreMapState);
  },
};
